import { filters } from '../pages/discovery/components/_utils/columnDefsGetter';
import { Column, ColumnValueChangedEvent } from 'ag-grid-community';

const onColumnValueChanged = (event: ColumnValueChangedEvent) => {
    const column = event && event.column;
    const colId = column && column.getColId();
    if (!colId) {
        return;
    }
    let filterType;
    if (column.getAggFunc()) {
        filterType = 'agSetColumnFilter';
    } else {
        filterType =
            filters[column.getColDef().type as string] || 'agSetColumnFilter';
    }
    safeRefreshFilters(event.api, event.columnApi, {
        colId,
        newFilterType: filterType,
    });
};

const safeRefreshFilters = (
    api: any,
    columnApi: any,
    options?: { colId?: string; newFilterType?: string }
) => {
    if (options?.colId) {
        const column = columnApi.getColumn(options.colId);
        if (!column) return;
        const colDef = column.getColDef();
        if (options.newFilterType && colDef.filter !== options.newFilterType) {
            colDef.filter = options.newFilterType;
        }
        api.destroyFilter(options.colId);
    } else {
        const allCols = columnApi.getAllColumns() || [];
        allCols.forEach((col: Column) => {
            api.destroyFilter(col.getColId());
        });
    }
    api.onFilterChanged();
};

export { onColumnValueChanged, safeRefreshFilters };
